<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep3ogauc.vue
*@ 컴포넌트설명 :[오클랜드] 예금 상품 > 금리 안내(정기적금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <div>
    <div class="cont-tit">
      <h6></h6>
      <div class="tbl-top-etc">{{ /* (연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>

    <table class="table -type02">
      <colgroup>
        <col width="40%" />
        <col width="25%" />
        <col />
      </colgroup>
      <tbody v-if="savingsDepositList.length > 0">
        <tr v-for="(sd, i) in savingsDepositList" :key="i">
          <th
            v-if="i === 0"
            :rowspan="savingsDepositList.length"
            scope="row"
          >
            {{ /*기간*/ $t("MDEP-01-02-02-06") }}
          </th>
          <th scope="row">
            {{ 
              lang == $config.LANG_KOR 
              ? sd.aplyTrmCtntKor
              : sd.aplyTrmCtntEng
            }}
          </th>
          <td>{{ sd.bascIrtCtnt }}%</td>
        </tr>
      </tbody>
    </table>

    <div class="info info-type4">
      <p>※ {{ /*중도해지 : 약정 이율 X 예금 기간에 해당하는 %*/ $t("MDEP-01-02-03-08") }}</p>
      <p>※ {{ /*만기후: 약정이율 X 1/2(1년이내), 1년 이상 %*/ $t("MDEP-01-02-03-09") }}</p>
      <p>※ {{ /*만기 1개월 전 조기해지 이율: 만기 총액 X 조기 해지 전 예치일수 X 조기 해지이율 / 36*/ $t("MDEP-01-02-03-10") }}</p>
      <p>- {{ /*조기해지이율 = 약정이율 + 1.5%*/ $t("MDEP-01-02-03-11") }}</p>
      <p>- {{ /*조기해지 전 예치일수 = 만기일 – 중도해지날짜*/ $t("MDEP-01-02-03-12") }}</p>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  components: {},
  data() {
    return {
      currentTab: 2,

      savingsDepositList: [],
    };
  },
  computed: {
    ...mapFields(["lang"]),
  },

  created() {
    this.go();
  },

  methods: {
    go() {
      const path = "/deposit/interest/intRateNz1List";

      let params = {
        interestInqInItemDTO: {
          aplyStartYmd: "",
          cncycd: "",
          dpostLnDstcd: "D",
          operGroupCd: "NZ1",
          ppsnCorpCtnt: "",
          prdctKndCtnt: "NZ103"
        },
      };

      // 정기적금
      this.$post(
        path,
        params,
        this.selectSucc
      );
    },

    selectSucc(res) {
      this.savingsDepositList = res.interstList;
    },
  },
};
</script>
